import React, { useEffect } from "react";
import "./ordercard.css";
import { useDispatch, useSelector } from "react-redux";
import { getproductDetails } from "../../appState/slices/product/productSlice";
import { useNavigate } from "react-router-dom";

const OrderCard = ({ productDetails }) => {
  const colors = useSelector((state) => state.color.colors);    
    const navigate = useNavigate();

    return (
        <div className="ordercard">
            <div className="ordercardimage-container">
                <img
                    className="ordercardimage"
                    src={productDetails.product.defaultImageUrl}
                    alt="Product Image"
                    onClick={() => navigate(`/${productDetails.product.name}/${productDetails.product._id}`)}
                />
            </div>
            <div className="ordercard-details">
                <div className="t5">
                    {productDetails.product.name}
                </div>
                <div className="ordercard-pricecontainer">
                <div className="t5 ordercard-price">
                ₹ {productDetails.finalTotal}
                </div>
                <div className="sizeandcolour t6">
                    <div className="orderquantity">
                       {productDetails.quantity} pcs |
                    </div>
                    <div className="colouredcircle" style={{ backgroundColor: colors?.colors[productDetails?.color].colorCode}}></div>
                </div>
                </div>
                
            </div>
        </div>
    )
};

export default OrderCard;